import React, { useMemo } from "react";
import shippingTime from "./ShippingTime.module.scss";

const ShippingTime = (props) => {
    const { shippingTimeInDays, shippingFree } = props;

    const offSetDate = new Date(
        new Date().getTime() + shippingTimeInDays * 24 * 60 * 60 * 1000,
    );

    offSetDate.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    offSetDate.setDate(
        offSetDate.getDate() + 3 - ((offSetDate.getDay() + 6) % 7),
    );
    // January 4 is always in week 1.
    const week1 = new Date(offSetDate.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    const shippingTimeKw = useMemo(
        () =>
            1 +
            Math.round(
                ((offSetDate.getTime() - week1.getTime()) / 86400000 -
                    3 +
                    ((week1.getDay() + 6) % 7)) /
                    7,
            ),
        // eslint-disable-next-line
        [week1],
    );

    const mondayOfWeek = useMemo(() => {
        const day = offSetDate.getDay();
        const diff = day === 0 ? -6 : 1 - day;
        const monday = new Date(offSetDate);
        monday.setDate(offSetDate.getDate() + diff);
        monday.setHours(0, 0, 0, 0);

        return monday.toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "2-digit",
        });
    }, [offSetDate]);

    const sundayOfWeek = useMemo(() => {
        const sunday = new Date(offSetDate);
        const day = offSetDate.getDay();
        const diff = day === 0 ? 0 : 7 - day;
        sunday.setDate(offSetDate.getDate() + diff);
        sunday.setHours(0, 0, 0, 0);

        return sunday.toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "2-digit",
        });
    }, [offSetDate]);

    const isExpress = shippingTimeInDays <= 7;

    return (
        <div className={shippingTime.info}>
            <span className={isExpress ? shippingTime['is--express'] : ''}>
                {isExpress ? 'Lieferbar in 2-5 Werktagen' : (
                    <>Lieferbar KW{shippingTimeKw}<br/>({mondayOfWeek} - {sundayOfWeek})</>
                )}
            </span>
            {(shippingFree) ? <span>zzgl. Service</span> : <span>zzgl. Mwst. <br />& Versand</span>}
        </div>
    );
};

export default ShippingTime;
